import { useNavigate } from "react-router-dom";
import { Button, Dropdown, Menu, Spin, type MenuProps } from "antd";
import { EasyAvatar } from "fin-web-components";
import { globalModel } from "../../../global/GlobalModel";
import { avatarDisplayWord } from "../../../utils/avatarDisplayWord";
import { resolveAppMediaUrl } from "../../../utils/resolveAppMediaUrl";
import { siteNavUserAvatarSize } from "../../../SiteConfig";
import { chineseWordmarkSrc } from "../../shell/chineseWordmark";
import { shellUserDropdownMenu } from "../../shell/shellUserDropdownMenu";
import type { SpaceNavItem } from "../SpaceType";

const spaceBrandLogo = `${process.env.PUBLIC_URL || ""}/logo.png`;

export function SpaceHeader(props: {
  spaceId: string;
  spacePresenceName: string;
  loaded: boolean;
  navItems: SpaceNavItem[];
  selectedKey: string;
  onLoginRequest: () => void;
  onFollowsClick: () => void;
  onOrdersClick: () => void;
}): JSX.Element {
  const {
    spaceId,
    spacePresenceName,
    loaded,
    navItems,
    selectedKey,
    onLoginRequest,
    onFollowsClick,
    onOrdersClick,
  } = props;
  const navigate = useNavigate();

  const menuItems: MenuProps["items"] = navItems.map((n) => ({
    key: n.routeKey,
    label: n.label,
  }));

  const onMenuClick: MenuProps["onClick"] = ({ key }) => {
    navigate(`/space/${spaceId}/${encodeURIComponent(String(key))}`);
  };

  const userMenu = shellUserDropdownMenu({
    navigate,
    onFollowsClick,
    onOrdersClick,
  });

  return (
    <div className="space-header-inner">
      <div
        className="space-header-brand shell-brand"
        onClick={() => navigate("/")}
        role="presentation"
      >
        <img
          className="shell-brand-img"
          src={spaceBrandLogo}
          alt="龙粉社"
          draggable={false}
        />
        <img
          className="shell-brand-wordmark"
          src={chineseWordmarkSrc("light")}
          alt=""
          draggable={false}
        />
        <span className="shell-brand-tagline" style={{ paddingTop: "2px" }}>
          当前正处于
          <span className="space-header-presence-name">{spacePresenceName}</span>
          空间
        </span>
      </div>
      <div className="space-header-center">
        <div className="space-header-nav" aria-label="空间导航">
          <Spin spinning={!loaded}>
            <div className="space-header-nav-inner">
              <Menu
                mode="horizontal"
                selectedKeys={[selectedKey]}
                items={loaded ? menuItems : []}
                onClick={onMenuClick}
                className="space-top-menu"
              />
            </div>
          </Spin>
        </div>
      </div>
      <div className="space-header-user">
        {globalModel.isLoggedIn ? (
          <Dropdown
            menu={userMenu}
            trigger={["click"]}
            getPopupContainer={() => document.body}
            overlayStyle={{ zIndex: 2000 }}
          >
            <div className="space-user">
              <EasyAvatar
                shape="circle"
                size={siteNavUserAvatarSize}
                url={resolveAppMediaUrl(globalModel.currentUser?.avatarUrl)}
                word={avatarDisplayWord(globalModel.currentUser?.name ?? "")}
                alt=""
                className="space-user-ea"
              />
              <span className="space-user-name">
                {globalModel.currentUser?.name ?? "用户"}
              </span>
            </div>
          </Dropdown>
        ) : (
          <div className="space-header-guest">
            <Button type="text" className="shell-dav">
              我是大V
            </Button>
            <Button type="text" className="shell-login" onClick={onLoginRequest}>
              登录/注册
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
